import { ProductPromoProps } from "models/WebShop";
import { Link } from "react-router-dom";
import { UrlPath } from "utility/routes";

const ProductPromo = ({
  companyId,
  path,
  name,
  description,
  linkText,
  alreadyBought = false,
  isActive = false
}: ProductPromoProps & { isActive?: boolean }) => {
  const imageSrc = `/min-bedrift-ill-${path}.svg`;
  const linkTarget = `${UrlPath.Account.WebShopBase}/${companyId}/${path}`;


  const shouldShowLink = !isActive;


  if (alreadyBought)
    return null;

  return (
    <li id={`shop-item-${path}`} key={name}>
      {shouldShowLink ? (
        <Link
          to={linkTarget}
          className="text-body d-flex flex-column flex-md-row gap-3 gap-md-4 align-items-md-center"
        >
          <img
            src={imageSrc}
            width="800"
            height="628"
            alt={name}
            className="img-fluid"
          />
          <div>
            <h2 className="fs-5">{name}</h2>
            <p className="mb-2">{description}</p>
            <p className="link-primary mb-0">{linkText}</p>
          </div>
        </Link>
      ) : (
        <div className="text-body d-flex flex-column flex-md-row gap-3 gap-md-4 align-items-md-center">
          <img
            src={imageSrc}
            width="800"
            height="628"
            alt={name}
            className="img-fluid"
          />
          <div>
            <h2 className="fs-5">{name}</h2>
            <p className="mb-2">{description}</p>
            <p className="text-muted mb-0">Dette produktet er under behandling</p>
          </div>
        </div>
      )}
    </li>
  );
};

export default ProductPromo;
